import { const_var, params } from "../../../redux/reducers/reducer";
import { getPercentPrice, sidingNameUpdateForWallTexture } from "../../../redux/reducers/utils";

export const setWainscotDefaultCompare = (buildingData, paramsData) => {
	let selectColor = "";
	let wallOrientation = paramsData.wallOrientation != undefined && paramsData.wallOrientation != "" ? paramsData.wallOrientation : paramsData.p_v_w ? "vertical" : "horizontal";
	let providedSiding = buildingData.allSidingOptions?.find((data) => data?.name?.toLowerCase() == const_var.compareSelSidingObj?.name?.toLowerCase())?.[`applicable_wainscot_${wallOrientation}`];
	let checkColorExist = buildingData.building_data?.color?.filter((item) => {
		if (item?.applied_on?.includes(wallOrientation + "_wainscot") && providedSiding?.includes(item?.sheet_name)) {
			return item;
		}
	});

	let compareColorExist = "";
	if (const_var.post_data.building?.wainscot?.image_name) {
		compareColorExist = checkColorExist.find((color) => color?.image_name && color.image_name == const_var.post_data.building?.wainscot?.image_name);
	} else {
		compareColorExist = checkColorExist.find((color) => color?.sheet_name == const_var.post_data.building?.wainscot?.sheet_name);
	}
	selectColor = compareColorExist ? compareColorExist : checkColorExist[0];
	return selectColor;
};

export const setWainscotDefault = (c_m_a, paramsData, colorsArr) => {
	c_m_a?.[paramsData.p_b_t]?.side_end_details?.forEach((wainscot) => {
		if (wainscot?.name == "metal") {
			wainscot["applicable_wainscot_horizontal"] = [];
			wainscot["applicable_wainscot_vertical"] = [];
			if (!wainscot.applicable_wainscot_horizontal.includes("metal")) wainscot.applicable_wainscot_horizontal.push("metal");
			if (!wainscot.applicable_wainscot_vertical.includes("metal")) wainscot.applicable_wainscot_vertical.push("metal");
		}
	});

	let checkColorExist = check_wainscot_color(c_m_a, paramsData, colorsArr);

	let findExistingColor = checkColorExist?.find(
		(filterColor) =>
			filterColor?.hex_value == const_var.post_data.building?.wainscot?.hex_value &&
			((filterColor?.sheet_name == const_var.post_data.building?.wainscot?.sheet_name && !filterColor?.image_name) ||
				(filterColor?.image_name && filterColor?.image_name == const_var.post_data.building?.wainscot?.image_name))
	);
	let trimColor = checkColorExist?.find((filterColor) => filterColor?.hex_value?.replace("#", "0x") == paramsData?.p_t_c?.replace("#", "0x"));
	if (findExistingColor != undefined) {
		paramsData.p_w_c_c = findExistingColor.hex_value.replace("#", "0x");
		paramsData.p_w_c_c_name = findExistingColor.name;
		paramsData.p_w_c_c_id = findExistingColor.id;
		if (findExistingColor?.image_name) {
			paramsData.wainscotTexture = sidingNameUpdateForWallTexture(findExistingColor.image_name.split(".")[0]);
		} else {
			paramsData.wainscotTexture = findExistingColor.sheet_name == "metal" ? (paramsData.p_v_w ? "vertical" : "none") : sidingNameUpdateForWallTexture(findExistingColor.sheet_name);
		}
	} else if (trimColor != undefined) {
		paramsData.p_w_c_c = trimColor.hex_value.replace("#", "0x");
		paramsData.p_w_c_c_name = trimColor.name;
		paramsData.p_w_c_c_id = trimColor.id;
		if (trimColor?.image_name) {
			paramsData.wainscotTexture = sidingNameUpdateForWallTexture(trimColor.image_name.split(".")[0]);
		} else {
			paramsData.wainscotTexture = trimColor.sheet_name == "metal" ? (paramsData.p_v_w ? "vertical" : "none") : sidingNameUpdateForWallTexture(trimColor.sheet_name);
		}
	} else if (checkColorExist?.length > 0) {
		paramsData.p_w_c_c = checkColorExist[0].hex_value.replace("#", "0x");
		paramsData.p_w_c_c_name = checkColorExist[0].name;
		paramsData.p_w_c_c_id = checkColorExist[0].id;
		if (checkColorExist[0]?.image_name) {
			paramsData.wainscotTexture = sidingNameUpdateForWallTexture(checkColorExist[0].image_name.split(".")[0]);
		} else {
			paramsData.wainscotTexture = checkColorExist[0].sheet_name == "metal" ? (paramsData.p_v_w ? "vertical" : "none") : sidingNameUpdateForWallTexture(checkColorExist[0].sheet_name);
		}
	}
	if (const_var.selSidingOption == "metal" && const_var.TypeEnum[paramsData.p_r_s] == "Regular" && paramsData.m_s_n != 12) {
		paramsData.wainscotTexture = "none";
		let isColorExsist = const_var.color?.find((val) => val.hex_value.replace("#", "0x") == paramsData.p_w_c_c);
		if (isColorExsist == undefined) {
			paramsData.p_w_c_c = paramsData.p_t_c;
			paramsData.p_w_c_c_name = paramsData.p_t_c_name;
			paramsData.p_w_c_c_id = paramsData.p_t_c_id;
		}
	}
};
export const applicableWainscot = () => {
	let wainscotTextureName = "";
	if (params.wainscotTexture.includes("stackstone")) wainscotTextureName = "stackstone";
	else if (params.wainscotTexture == "none" || params.wainscotTexture == "vertical") wainscotTextureName = "metal";
	else wainscotTextureName = params.wainscotTexture;

	return wainscotTextureName;
};
export const check_wainscot_color = (c_m_a, paramsData, colorsArr) => {
	let wallOrientation = paramsData.wallOrientation != undefined && paramsData.wallOrientation != "" ? paramsData.wallOrientation : paramsData.p_v_w ? "vertical" : "horizontal";
	let providedSiding = c_m_a?.[paramsData.p_b_t]?.side_end_details?.find((data) => data?.name?.toLowerCase() == const_var.selSidingOption?.toLowerCase())?.[`applicable_wainscot_${wallOrientation}`];
	let checkFor = false;
	colorsArr?.map((color) => {
		if (color?.sheet_name == "metal" && color.applied_on?.includes(`${wallOrientation}_wainscot`)) {
			checkFor = true;
		}
	});
	let arrayFilterWithSiding = [];
	colorsArr?.map((color) => {
		if (color?.sheet_name == "metal") {
			arrayFilterWithSiding.push(color);
		} else if (color.applied_on?.includes(`${wallOrientation}_wainscot`) && providedSiding?.includes(sidingNameUpdateForWallTexture(color?.sheet_name))) {
			arrayFilterWithSiding.push(color);
		}
	});
	let checkColorExist =
		checkFor || (checkFor == false && const_var.selSidingOption != "metal")
			? colorsArr?.filter((item) => {
					if (item?.applied_on?.includes(wallOrientation + "_wainscot") && providedSiding?.includes(item?.sheet_name)) {
						return item;
					} else if (!providedSiding?.includes(item?.sheet_name) && item?.sheet_name == const_var.selSidingOption) {
						return item;
					}
				})
			: arrayFilterWithSiding;

	return checkColorExist;
};
export const updateWainscotPriceFlag = () => {
	let updateWainscotPrice = false;
	if (const_var.wainscot_filter_data?.length > 0 && const_var.wainscot_filter_data?.[0].price_type != "$") {
		updateWainscotPrice = true;
	} else if (const_var.wainscot_metal.price_type != "$") {
		updateWainscotPrice = true;
	}
	if (updateWainscotPrice) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
	}
};
export const calWainscotSiding = (post_data, t_c, leantoPriceCalculation, pricing_data = undefined, second = undefined, wallCommonPrice, callFrom, AllleantoBasePrice = undefined) => {
	let cost = 0;
	const wainscoatData = const_var.c_m_a[params.p_b_t]?.wainscot_details || [];
	const { wallOrientation, p_w, p_d } = params;
	const filterWainscoat = wainscoatData.filter((wainscoat) => (wainscoat.width && Number(wainscoat.width) === Number(p_w)) || (wainscoat.length && Number(wainscoat.length) === Number(p_d)));
	if (!filterWainscoat.length) return 0;
	const sqft = params.p_w * params.p_d;
	const ft = params.p_w + params.p_d;
	filterWainscoat.forEach((item) => {
		const priceObj = item[wallOrientation];
		if (!priceObj) return;
		const price = Number(priceObj.price || 0);
		switch (priceObj.price_type?.toUpperCase()) {
			case "DOLLAR":
			case "$":
				cost += price;
				break;
			case "SQFT":
				cost += price * sqft;
				break;
			case "FT":
				cost += price * ft;
				break;
			case "PERCENTAGE":
			case "%":
				cost += getPercentPrice({ price, percentage_of: priceObj.percentage_of, post_data });
		}
	});

	return cost;
};
export const updateWainscotOnWallChange = () => {
	if (params.p_w_c_n) {
		if (
			params.p_f_w == "Close" ||
			params.p_b_w == "Close" ||
			params.p_l_w == "Close" ||
			params.p_r_w == "Close" ||
			params.p_u_c ||
			params.cB_addStorage_check_left ||
			params.cB_addStorage_check_right ||
			params.p_b_c_b_l_f == "Close" ||
			params.p_b_c_b_l == "Close" ||
			params.p_b_c_b_l_b == "Close" ||
			params.add_storage_check ||
			params.p_b_c_b_r_f == "Close" ||
			params.p_b_c_b_r == "Close" ||
			params.p_b_c_b_r_b == "Close" ||
			params.add_storage_check_right ||
			params.p_b_c_b_f_f == "Close" ||
			params.p_b_c_b_f_b == "Close" ||
			params.p_b_c_b_f_l == "Close" ||
			params.add_storage_check_front ||
			params.p_b_c_b_b_f == "Close" ||
			params.p_b_c_b_b_b == "Close" ||
			params.p_b_c_b_b_l == "Close" ||
			params.add_storage_check_back ||
			params.p_f_w == "Half Dutch End" ||
			params.p_f_w == "Half End" ||
			params.p_b_w == "Half Dutch End" ||
			params.p_b_w == "Half End" ||
			params.p_b_c_b_l_f == "Half Dutch End" ||
			params.p_b_c_b_l_f == "Half End" ||
			params.p_b_c_b_l_b == "Half Dutch End" ||
			params.p_b_c_b_l_b == "Half End" ||
			params.p_b_c_b_b_f == "Half Dutch End" ||
			params.p_b_c_b_b_f == "Half End" ||
			params.p_b_c_b_b_b == "Half Dutch End" ||
			params.p_b_c_b_b_b == "Half End" ||
			params.p_b_c_b_f_f == "Half Dutch End" ||
			params.p_b_c_b_f_f == "Half End" ||
			params.p_b_c_b_f_b == "Half Dutch End" ||
			params.p_b_c_b_f_b == "Half End" ||
			params.p_b_c_b_r_f == "Half Dutch End" ||
			params.p_b_c_b_r_f == "Half End" ||
			params.p_b_c_b_r_b == "Half Dutch End" ||
			params.p_b_c_b_r_b == "Half End"
		) {
			const_var.showWainscotJSX = true;
		} else {
			const_var.showWainscotJSX = false;
			params.p_w_c_n = false;
			const_var.UpdatedPriceData.wainscot_price_changed = true;
		}
	}
};
export const calcWainscotPrice = (fullClosedWidthCalc, fullClosedLengthCalc, costObj) => {
	let Price = 0;
	Price = (parseFloat(fullClosedWidthCalc) + parseFloat(fullClosedLengthCalc)) * 3 * costObj.cost;
	return parseFloat(Price);
};
export const findWainscotTexture = (data) => {
	let sidingName = data.image_name?.split(".")[0];
	let wainscotTexture = "none";
	if (sidingName != undefined) {
		wainscotTexture = sidingNameUpdateForWallTexture(sidingName);
	} else if (data.sheet_name == "metal") {
		if (params.wallOrientation != undefined && params.wallOrientation != "") {
			wainscotTexture = params.wallOrientation == "vertical" ? "vertical" : "none";
		} else {
			if (params.p_v_w == true) {
				wainscotTexture = "vertical";
			} else {
				wainscotTexture = "none";
			}
		}
	} else if (data.sheet_name == undefined) {
		if (params.p_v_w == true) {
			wainscotTexture = "vertical";
		} else {
			wainscotTexture = "none";
		}
	} else {
		wainscotTexture = sidingNameUpdateForWallTexture(data.sheet_name);
	}

	return wainscotTexture;
};
export const calculateWainscotPrice = ({ post_data, t_c, data, UpdatePriceRecord, utlis }) => {
	if (params.p_w_c_n) {
		post_data.building.wainscot_type = "full-building";
		post_data.building.wainscot_side = "both";
		post_data.building.wainscot_end = "both";
		post_data.building.wainscot = const_var.c_m_a_Colors[params.p_w_c_c_id];
	}

	const checkWithNew = (const_var?.c_m_a?.[params.p_b_t]?.wainscot_details?.length ?? 0) > 0;

	if (checkWithNew && params.p_w_c_n) {
		const finalCostSecond = calWainscotSiding(post_data, t_c, undefined, data, true, undefined, "first");

		if (finalCostSecond > 0) {
			const isValidCost = utlis.num(finalCostSecond);

			post_data.building.wainscot_price =
				UpdatePriceRecord === true && const_var.UpdatedPriceData?.wainscot_price_changed !== true ? const_var.UpdatedPriceData.wainscot_price : isValidCost ? utlis.num(finalCostSecond) : 0;

			t_c += post_data.building.wainscot_price;
		}
	}

	if (const_var.showWallColorJSX === true) {
		post_data.building.wall_color = const_var.c_m_a_Colors[params.p_w_c_id];
	}

	post_data.building.roof_color = const_var.c_m_a_Colors[params.p_r_c_id];

	post_data.building.trim_color = const_var.c_m_a_Colors[params.p_t_c_id];

	post_data.building.garageDoorColor = const_var.garageDoorColor[params.g_d_c_id];

	post_data.building.roof_color_price = 0;
	post_data.building.wall_color_price = 0;
	post_data.building.trim_color_price = 0;
	post_data.building.wainscot_color_price = 0;

	return t_c;
};
